
import { Component, Vue, Prop, Watch, Emit, Mixins } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";
import { Task, TaskCategory, TaskGroup } from "@/store/tasks/types";
import { DispatchRequest } from "@/store/mobile/types";
import { GuardTour, GuardTourStep } from "@/store/guard-tours/types";
import { get } from "lodash";
import { FeaturesList } from "@/store/types";
import MobileEventTask from "@/components/mobile/dispatch/MobileEventTask.vue";
import GuardTourMixin from "@/components/mobile/dispatch/GuardTourMixin";

const Mobile = namespace("mobile");
const Tasks = namespace("tasks");
const GuardTours = namespace("GuardTours");

@Component({
	components: {
		"mobile-event-task": MobileEventTask
	}
})
export default class GuardTourActions extends Mixins(GuardTourMixin) {
	@Prop({ default: null, type: Number }) public tourEventId: number;
	@Prop({ default: null, type: Number }) public guardTourId: number;

	@Tasks.Action fetchTaskTypes: () => Promise<void>;
	@Tasks.Action fetchEventTasks: ({ eventId }) => Promise<void>;

	@Tasks.Getter("getTasks") tasks: Task[];
	@Mobile.Getter("getActiveDispatchRequest") activeDispatchRequest: DispatchRequest;

	@GuardTours.Action fetchGuardTour;
	@GuardTours.Getter getGuardTour: (guardTourId: number) => GuardTour;

	@Getter("getFeaturesList") featuresList: FeaturesList;

	private pollInterval: NodeJS.Timer | null = null;

	private get areMobileActionPlansEnabled(): boolean {
		return get(this.featuresList, ["Mobile", "GuardTours", "ActionPlans"]);
	}	

	private async mounted() {
		if (this.areMobileActionPlansEnabled) {
			// required to load the available task types for an action plan
			await this.fetchTaskTypes();
			await this.fetchGuardTour(this.guardTourId);

			if (this.currentTourStep.scriptId) {
				// inital load (required otherwise there is a 5 second delay before showing the tasks component)
				await this.pollForTasks();

				// polling checking
				this.pollInterval = setInterval(async () => this.pollForTasks(), 5000);
			}		
		}
	}

	public async pollForTasks() {
		if (this.tourEventId) {
			await this.fetchEventTasks({ eventId: this.tourEventId });
		}
	}

	public beforeDestroy() {
		// Stop polling
		clearInterval(this.pollInterval);
	}			

	private get showGuardActions(): boolean {
		return (
			this.areMobileActionPlansEnabled &&
			this.tourEventId &&
			this.tourEventId > 0 &&
			this.tasksForStep &&
			this.tasksForStep.length > 0 &&
			this.tourStepHasActions
		);
	}	

	public get taskProgress(): string {
		return `${this.totalTasks.completed}/${this.totalTasks.count}`;
	}

	private get totalTasks(): { count: number; completed: number } {
		let count = this.tasksForStep.length;
		let completed = this.tasksForStep.filter((task: Task) => task.completed).length;

		return { count, completed };
	}
}
